export class UrlHelper {
  static account_url(url) {
    return `/${document.getElementsByName("current-account-id")[0].getAttribute("content")}${url}`
  }
}
